<template>
  <div class="banner-box">
    <div class="banner-list-box">
		 <div class="item-box">
			 <img src="../assets/banner/Welcome_to_TOZO_Community.png" alt="Welcome to TOZO Community"/>
			 <h2 class="title">{{ $t('homePage.banner.Welcome') }}</h2>
		 </div>
		 <!-- <Swiper :item="banner_obj"></Swiper> -->
      <!-- <h1>欢迎来到社区</h1> -->
      <!-- <p>这里是社区网站的横幅区域</p> -->
    </div>
  </div>
</template>

<script>
import Swiper from './public/Swiper.vue'

export default {
	name: 'Banner',
	components: { Swiper },

	// props: {
	// 	Post_List: {
	// 		type: Array,
	// 		default: []
	// 	},
	// 	parent_type: {
	// 		type: String,
	// 		default: []
	// 	},
	// 	follow_button: {
	// 		type: Boolean,
	// 		default: false,
	// 	},
	// },
	data() {
		return {
			banner_obj:{
				id: 1,
				src:"Welcome_to_TOZO_Community.png"
			},
		}
	},
	
	// 监听
	watch: {
		// "Post_List": {
		// 	handler: function (newValue, oldValue) {
		// 		this.list = this.Post_List
		// 	},
		// 	deep: true
		// },
	},
	
	// beforeCreate() {
		
	// }
	
  created () {
	  
  },
  
  mounted() {
	  // this.list = this.Post_List
  },
  
  methods:{
	//查看 粉丝或关注人信息
	check_information(item){
		console.log(item)
	},
	
	change_more(item){
		console.log(item)
	},
	
	//查看详情
	view_details(item){
		console.log(item)
	},
	
  }
}
</script>

<style lang="less" scoped>
	.banner-box{
		margin-top: 10px;
		width: 100%;
		display: flex;
		justify-content: center;
	}
	.banner-list-box {
		width: 100%;
		max-height: 200px;
		max-width: 1280px;
		/* padding: 10px 10px; */
		/* min-height: 150px; */
		border-radius: 8px;
		text-align: center;
		/* display: flex; */
		/* justify-content: center; */
		/* align-items: center; */
		/* flex-direction: column; */
		/* background-color: #111111; */
		color: #ffffff;
		overflow: hidden;
	}
	
	@media screen and (max-width: 1320px) {
	  .banner-list-box {
			border-radius: 0px;
	  }
	}
	.item-box{
		position: relative;
		width: 100%;
		img{
			width: 100%;
			height: auto;
			border-radius: 8px;
			display: block;
		}
		.title{
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			font-weight: 400;
			font-size: 24px;
			color: #FFFFFF;
			line-height: 28px;
			text-align: center;
			font-style: normal;
			text-transform: none;
			background-color: rgba(0, 0, 0, 0.01) !important;
		}
	}
	.banner-list-box .picture_and_video_box{
		margin-top: 0px;
		max-height: 100%;
	}
	.media-carousel .swiper-slide{
		width: 100% !important;
		max-height: 160px;
	}
</style>
